// extracted by mini-css-extract-plugin
module.exports = {"label":"qglVK0","color-sample":"g4LkFV","colorSample":"g4LkFV","disabled":"zSyFva","input":"cag6Wo"};